import { SdgAlignmentStrength, SdgAlignmentValence } from '@upright/common/model/output/scores/sdg-alignment/types';
import { useRefWidth } from '@upright/ui/common/generic/hooks';
import { toPercentageValue } from '@upright/ui/common/generic/utilities/format';
import { isNil } from 'lodash';
import { CSSProperties, useRef } from 'react';
import styled from 'styled-components';
import { getSdgColor, getSdgTextColorOnColoredBackground } from '../../../shared';

interface BarProps {
  value?: number;
  alignment: number;
  valence: SdgAlignmentValence;
  strength: SdgAlignmentStrength;
  style?: CSSProperties;
}

export function ColorBar(props: BarProps) {
  const barRef = useRef<HTMLDivElement | null>(null);
  const barWidth = useRefWidth(barRef);
  const barWidthThreshold = 25;
  const barWideEnoughForText = barWidth >= barWidthThreshold;

  const showText = barWideEnoughForText && !isNil(props.value);

  const text = showText ? `${toPercentageValue(props.value, 0)}%` : '';

  const textColor = getSdgTextColorOnColoredBackground(props.valence, props.strength);
  const barColor = getSdgColor(props.valence, props.strength);

  return (
    <Root
      ref={barRef}
      style={{
        ...props.style,
        flexBasis: `${props.alignment}%`,
        color: textColor,
        backgroundColor: barColor,
        opacity: 0.9,
      }}
    >
      {text}
    </Root>
  );
}

const Root = styled.div`
  border-radius: 2px;
  flex-grow: 1;
  flex-shrink: 1;
  border: 0px solid transparent;
  height: 1.3em;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;
